import mediaQueries from '../media-queries';

export function getMediaQuery(name: string) {
  let suffix = name.split('_').pop()?.replace('.css', '');
  return mediaQueries[suffix as keyof typeof mediaQueries];
}
